import { __assign } from "tslib";
import * as actionTypes from '../constants/actionTypes';
// locationState is a shape with the following attributes:
// { projectID, screenID, highlightedComment, inHandoff, isEmbedded,
//   hotspotID, hideOpenInMobile, isFrameless, isInTheExploreView }
// currentLocation is the location object
export function locationChanged(locationState, currentLocation) {
    return __assign(__assign({ type: actionTypes.LOCATION_CHANGED }, locationState), { currentLocation: currentLocation });
}
